import React, { useState } from "react";

/** The brand mark as a spinner: dark track with the green arc sweeping round it. */
export const LoadingRing = ({ size = 44, className = "" }) => (
    <svg viewBox="0 0 240 240" width={size} height={size} className={`block ${className}`}
        data-testid="loading-ring" role="img" aria-label="Loading">
        <circle cx="120" cy="120" r="88" fill="none" stroke="#3F3F3F" strokeWidth="34" opacity="0.28" />
        <g className="logo-ring__arc is-loading" style={{ transformOrigin: "120px 120px" }}>
            <circle cx="120" cy="120" r="88" fill="none" stroke="#7DD856" strokeWidth="34"
                strokeLinecap="round" strokeDasharray="110 553" />
        </g>
    </svg>
);

/** The same ring, sized to sit inside a button label. */
export const ButtonRing = ({ size = 16, label = "" }) => (
    <span className="inline-flex items-center gap-2" data-testid="button-ring">
        <LoadingRing size={size} />{label}
    </span>
);

/** Instant actions (like adding to cart) still get a beat of ring so the click feels answered. */
export const useBusyAction = (ms = 650) => {
    const [busy, setBusy] = useState(false);
    const run = async (fn) => {
        if (busy) return;
        setBusy(true);
        const started = Date.now();
        try {
            await fn();
        } finally {
            setTimeout(() => setBusy(false), Math.max(ms - (Date.now() - started), 0));
        }
    };
    return [busy, run];
};

export const PageLoader = ({ label = "LOADING…", className = "pt-40 pb-40" }) => (
    <div className={`flex flex-col items-center justify-center gap-4 ${className}`} data-testid="page-loader">
        <LoadingRing size={52} />
        <span className="mono text-[10px] tracking-[0.2em] text-zinc-500">{label}</span>
    </div>
);

export default PageLoader;
